import { FontWeights, getTheme, Text } from 'office-ui-fabric-react';
import React from 'react';
import { SystemPanel } from '../SystemPanel';
import { jsx as _jsx } from "react/jsx-runtime";
export const HoldingSplash = _ref => {
  let {
    message
  } = _ref;
  const {
    palette: {
      blue
    }
  } = getTheme();
  return /*#__PURE__*/_jsx(SystemPanel, {
    iconName: "Airplane",
    iconColour: blue,
    title: "Welcome to Buzz",
    content: /*#__PURE__*/_jsx(Text, {
      styles: {
        root: {
          fontWeight: FontWeights.bold
        }
      },
      children: message
    })
  });
};